import { Injectable } from "@angular/core";
import { Member } from "src/app/backend/models/member/member";
import { Tenant } from "src/app/backend/models/tenant/tenant";
import {
  clearOpenPanelSession,
  identifyOpenPanelMember,
  initOpenPanel,
  isOpenPanelEnabled,
  trackOpenPanelProductEvent
} from "src/app/support/openpanel";

@Injectable()
export class OpenPanelService {
  init(): void {
    initOpenPanel();
  }

  isEnabled(): boolean {
    return isOpenPanelEnabled();
  }

  identifyMember(member: Member, tenant: Tenant): void {
    identifyOpenPanelMember(member, tenant);
  }

  trackProductEvent(
    area: string,
    entity: string,
    action: string,
    properties: Record<string, string | undefined>
  ): void {
    trackOpenPanelProductEvent(area, entity, action, properties);
  }

  clearSession(): void {
    clearOpenPanelSession();
  }
}
